import { useParams } from "react-router-dom";

import { useAppSelector, useProtectedUserRoleSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { getRouteEditorCapabilities } from "./RouteEditor.policy";
import { RouteEditorCreate } from "./RouteEditorCreate";
import { RouteEditorEdit } from "./RouteEditorEdit";
import { RouteEditorMyRoute } from "./RouteEditorMyRoute";

function RouteEditor() {
    const { routeId } = useParams();
    const role = useProtectedUserRoleSelector();
    const { routeList } = useAppSelector((state) => state.manager);

    const capabilities = getRouteEditorCapabilities(role);

    if (capabilities.isSelfRouteOnly) {
        return <RouteEditorMyRoute capabilities={capabilities} />;
    }

    if (!routeId) {
        return <RouteEditorCreate capabilities={capabilities} />;
    }

    const currentRoute = routeList?.[routeId];

    if (!currentRoute) {
        return <NotFound />;
    }

    return (
        <RouteEditorEdit
            currentRoute={currentRoute}
            routeId={routeId}
            capabilities={capabilities}
        />
    );
}

export default RouteEditor;
